import { useLocation } from "react-router-dom";

// get debug flag to be able to pass to api, but check for debug data in api response
export function useDebug() {
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    return searchParams.get("debug") ? 1 : 0;
}
